import { defineComponent as _defineComponent } from 'vue';
import { useListIrosQuery, useListStakeholdersQuery, useListValueChainsQuery } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup: function setup(__props) {
    var _useListValueChainsQu = useListValueChainsQuery(),
      valueChainListResult = _useListValueChainsQu.result,
      refetch = _useListValueChainsQu.refetch,
      loading = _useListValueChainsQu.loading;
    var _useListStakeholdersQ = useListStakeholdersQuery({
        filters: {
          notLinkedToActivities: []
        }
      }),
      stakeholderResult = _useListStakeholdersQ.result,
      refetchStakeholders = _useListStakeholdersQ.refetch;
    var _useListIrosQuery = useListIrosQuery({
        input: {
          activityIds: [null]
        }
      }),
      iroResult = _useListIrosQuery.result,
      refetchIros = _useListIrosQuery.refetch;
    var irosWithoutActivity = computed(function () {
      var _iroResult$value;
      return (_iroResult$value = iroResult.value) === null || _iroResult$value === void 0 ? void 0 : _iroResult$value.listIros;
    });
    var items = computed(function () {
      var _valueChainListResult;
      return (_valueChainListResult = valueChainListResult.value) === null || _valueChainListResult === void 0 ? void 0 : _valueChainListResult.listValueChains;
    });
    var stakeholders = computed(function () {
      var _stakeholderResult$va;
      return stakeholderResult === null || stakeholderResult === void 0 ? void 0 : (_stakeholderResult$va = stakeholderResult.value) === null || _stakeholderResult$va === void 0 ? void 0 : _stakeholderResult$va.listStakeholders;
    });
    return {
      __sfc: true,
      valueChainListResult: valueChainListResult,
      refetch: refetch,
      loading: loading,
      stakeholderResult: stakeholderResult,
      refetchStakeholders: refetchStakeholders,
      iroResult: iroResult,
      refetchIros: refetchIros,
      irosWithoutActivity: irosWithoutActivity,
      items: items,
      stakeholders: stakeholders
    };
  }
});